import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import SearchHeader from '../../headers/searchHeader';
import { getUserUrlPrefix } from '../../../auth/selectors';
import BarbersPageTabs from './barbersPageTabs';

const BarbersWrapper = ({
  children,
  addBarberLink,
}) => (
  <div>
    <SearchHeader heading="Barbers" type="barber" button="Add barber" link={addBarberLink} />
    <div className="c-wrapper o-page-height">
      <BarbersPageTabs />
      {children}
    </div>
  </div>
);

BarbersWrapper.propTypes = {
  children: PropTypes.node,
  addBarberLink: PropTypes.string,
};

BarbersWrapper.defaultProps = {
  children: null,
  addBarberLink: '',
};

export default compose(
  withRouter,
  connect(state => ({
    addBarberLink: `${getUserUrlPrefix(state)}/barbers/add`,
  })),
)(BarbersWrapper);
